<template>
  <div class="col">
    <appResolutionHeader
      :majority-name="findMajorityData(event.majority_id).name"
      :vote-order="voteOrder"
      :resolution="resolution"
      :parent-resolution-name="parentResolution.name"
      :parent-resolution-number="parentResolution.resolution_number"
      :parent-resolution-description="parentResolution.description"
      :is-revote-event-resolution="isRevoteEventResolution"
    />

    <appResolutionVotes
      v-if="event.votes && checkIfShowVotes()"
      :events-major-changes="eventsMajorChanges"
      :event="event"
      :resolution="resolution"
    />

    <appResolutionFooter
      v-if="!event.isParent"
      :resolution="resolution"
      :event="event"
      :majority-name="findMajorityData(event.majority_id).name"
    />
  </div>
</template>

<script>
import resolutionHeader from "./resolutionDetail/header";
import resolutionVotes from "./resolutionDetail/votes";
import resolutionFooter from "./resolutionDetail/footer";

export default {
  components: {
    appResolutionHeader: resolutionHeader,
    appResolutionVotes: resolutionVotes,
    appResolutionFooter: resolutionFooter,
  },
  props: {
    event: {
      type: Object,
      require: true,
    },
    voteOrder: {
      type: Number,
      require: true,
    },
    resolution: {
      type: Object,
      require: true,
    },
    eventsMajorChanges: {
      type: Array,
      require: true,
    },
    parentResolution: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isRevoteEventResolution: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    checkIfShowVotes() {
      return (
        this.resolution.status != this.meetingResolutionStatuses.not_resolved &&
        this.resolution.status != this.meetingResolutionStatuses.sans_vote &&
        this.resolution.status != this.meetingResolutionStatuses.not_voted
      );
    },
  },
};
</script>
